// extracted by mini-css-extract-plugin
module.exports = {"container":"HeaderLogo_container___AnwK","leaf":"HeaderLogo_leaf__C025f","small":"HeaderLogo_small__KGE9C","laufid":"HeaderLogo_laufid__UjESk"};